import { createFileRoute } from "@tanstack/react-router";
import { VendorEinstellungenPage } from "@/components/vendor/settings/VendorEinstellungenPage";

export const Route = createFileRoute("/vendor/einstellungen")({
  head: () => ({ meta: [{ title: "Einstellungen · Venue Portal" }] }),
  component: VendorEinstellungenRoute,
});

function VendorEinstellungenRoute() {
  return <VendorEinstellungenPage />;
}
